import debounce from 'lodash/debounce';
import socialGalleryCarousel from './socialGalleryCarousel';
import { initSingleGallery, openOverlay, initBodyInteractiveElements } from './gallery';
import { getBreakpoint, setSkipLink } from './_utils';

export default function init() {
	const baseSelector = 'SocialGallery';
	const baseSelectorWrapper = `${baseSelector}-wrapper`;

	const selectors = {
		base: `.${baseSelector}`,
		baseSelectorWrapper: `.${baseSelectorWrapper}`,
		gallery: `.${baseSelector}-gallery`,
		galleryComponent: '.Gallery',
		galleryOverlay: '.Gallery-overlay',
		galleryList: `.${baseSelector}-list`,
		button: `.${baseSelector}-button`,
		loader: `.${baseSelector}-loader`,
	};

	const classes = {
		galleryList: `${baseSelector}-list`,
		loader: `${baseSelector}-loader`,
		visible: '--visible',
		hidden: '--hidden',
		flickity: '--flickity',
		square: '--square',
		portrait: '--portrait',
		landscape: '--landscape',
	};

	let carouselInitialized = false;

	const setCarouselVisibility = () => {
		const isSmall = getBreakpoint() === 'small';

		$(selectors.gallery).each((_, galleryElement) => {
			$(galleryElement)
				.find(selectors.galleryList)
				.toggleClass(`${classes.galleryList}${classes.flickity}`, isSmall);

			if (!carouselInitialized) {
				socialGalleryCarousel($(galleryElement));
				carouselInitialized = true;
			}
		});
	};

	const setupFlickityAction = ($gallery, button, flickity) => {
		// Open the overlay in the correct button on click
		const $button = $(button);
		$button.on('click', e => {
			const galleryOverlay = $gallery.find(selectors.galleryOverlay);
			flickity.instance = openOverlay(galleryOverlay, flickity.instance, e.target);
			const index = $button.data('index') || 0;
			// Open overlay
			flickity.instance.select(index, true, true);
		});
	};

	const hideSocialGallery = () => {
		$(selectors.loader).addClass(`${classes.loader}${classes.hidden}`);
		$(selectors.baseSelectorWrapper).addClass(`${baseSelectorWrapper}${classes.hidden}`);
	};

	$(`.${baseSelector}`).each(function (i, socialGallery) {
		const $gallery = $(socialGallery).find(selectors.gallery);

		if ($gallery.length > 0) {
			const endpoint = $gallery.data('endpoint');
			var cacheBust = Math.floor(new Date().getTime() / 43200000); //43200000 = (1000 * 60 * 60 * 12)

			$.ajax({
				dataType: 'html',
				url: endpoint + '.' + cacheBust + '.html',
				type: 'GET',
				success: function (data) {
					$gallery.html(data);
					const galleryInterval = setInterval(() => {
						// data is an empty array when Olapic API returns error
						if ($(data).length === 0) {
							hideSocialGallery();
							clearInterval(galleryInterval);
						}

						if ($gallery.find(selectors.button).length > 0) {
							$(selectors.base).addClass(`${baseSelector}${classes.visible}`);
							$(selectors.loader).addClass(`${classes.loader}${classes.hidden}`);

							let flickity = initSingleGallery(
								$gallery.find(selectors.galleryComponent)
							);
							$(socialGallery)
								.find(selectors.button)
								.each((_, button) => {
									setupFlickityAction($gallery, button, flickity);
								});

							setCarouselVisibility();
							initBodyInteractiveElements();
							setSkipLink($(selectors.baseSelectorWrapper));
							clearInterval(galleryInterval);
						}
					}, 50);
				},
				error: hideSocialGallery,
			});
		}
	});

	$(window).on(
		'resize',
		debounce(() => {
			if (carouselInitialized) setCarouselVisibility();
		}, 70)
	);
}
